import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { RequireSession } from '@/components/RequireSession';
import { LandingPage } from '@/pages/LandingPage';
import { TasksPage } from '@/pages/TasksPage';
import { StatusPage } from '@/pages/StatusPage';

/**
 * Routes (under the `/room/` base; BrowserRouter basename handles the prefix):
 *   /        landing — reads the invite from `?t=`, exchanges, routes onward, or shows the gate
 *   /tasks   the task flow  (guarded — an active in-memory session is required)
 *   /status  the progress view (guarded)
 * Unknown paths fall back to `/`, preserving the `?t=` invite so a deep-link refresh still recovers.
 */
export default function App() {
  const { search } = useLocation();
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route
        path="/tasks"
        element={
          <RequireSession>
            <TasksPage />
          </RequireSession>
        }
      />
      <Route
        path="/status"
        element={
          <RequireSession>
            <StatusPage />
          </RequireSession>
        }
      />
      <Route path="*" element={<Navigate to={{ pathname: '/', search }} replace />} />
    </Routes>
  );
}
